var $ = require('../modules/jquery');
var enquire = require('../modules/enquire');
var Swiper = require('../modules/swiper');
var _throttle = require('lodash/throttle');

var $filters;
var filterSwipes;

// Functions
// ---------------------------------------------------------------------------
function initFilterSwipes() {
  var viewport = $(window).width();

  // add viewport width to container
  $filters.css('width', viewport);

  // initialize swip
  if (typeof filterSwipes === 'undefined' || filterSwipes.destroyed) {
    filterSwipes = new Swiper('#formblock--search-filters', {
      slidesPerView: 'auto',
      spaceBetween: 32,
      hashNavigation: {
        watchState: true,
      },
    });
  }
}

function destroyFilterContainer() {
  // remove viewport width from container
  $filters.css('width', '');

  // destroy swiper
  if (!filterSwipes.destroyed) {
    filterSwipes.destroy();
  }
}

function breakpointCheck() {
  enquire.register('screen and (max-width: 639px)', {
    match: function () {
      initFilterSwipes();
    },
    unmatch: function () {
      destroyFilterContainer();
    }
  });
}

function clearSearchFieldButton($form) {
  var $wrap = $('.formblock__clear-input-wrap', $form);
  var $clearBtn = $('[data-clear-search-input-btn]', $wrap);
  var $input = $('[name="search_api_fulltext"]', $wrap);

  if ($wrap.length > 0) {
    $clearBtn.on('click', function () {
      $input.val('');
    });

    $input.on('keyup', function () {
      if ($input.val().length > 0) {
        $clearBtn.show();
      } else {
        $clearBtn.hide();
      }
    });

    if ($input.val().length > 0) {
      $clearBtn.show();
    }
  }

}

// Initializations
// ---------------------------------------------------------------------------
$(document).ready(function () {
  var $form = $('#views-exposed-form-search-search-results');
  var $formRadioButtons = $form.find('[type="radio"]');
  var $formSearchButton = $form.find('button');
  var $formSubmitButton = $form.find('#edit-submit-search');
  var $formSearchInput = $form.find('[name="search_api_fulltext"]');

  $filters = $('#formblock--search-filters');
  if ($filters.length) {
    breakpointCheck();
  }

  // Tie visible search button to hidden submit button
  $formSearchButton.on('click', function (e) {
    e.preventDefault();
    $formSubmitButton.trigger('click');
  });

  $formSearchInput.on('keydown', function (e) {
    // Enter button key code is 13
    if (e.keyCode === 13) {
      e.preventDefault();
      $formSubmitButton.trigger('click');
    }
  });

  // Submit form when tab is selected
  $formRadioButtons.change(function () {
    $formSubmitButton.trigger('click');
  });

  clearSearchFieldButton($form);

});

$(window).on('resize', _throttle(function () {
  if ($filters.length) {
    breakpointCheck();
  }
}, 100));



//////////////////
// WEBPACK FOOTER
// ./web/themes/contrib/nccourts-theme/assets/src/js/components/search-results.js
// module id = 40
// module chunks = 10